import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Createconfiguration from "./CreateConfiguration";
import Firebasesetting from "./Firebasesetting";
import Paymentmethod from "./Paymentmethod";


export default function ConfigSetting() {
  return (
    <Switch>
      <Redirect exact={true} from="/config-setting" to="/config-setting/configuration" />

      {/* Layout */}
      <Route exact={true} path="/config-setting/configuration" component={Createconfiguration} />
      <Route exact={true} path="/config-setting/payment" component={Paymentmethod} />
      <Route exact={true} path="/config-setting/firebase" component={Firebasesetting} />
     
    </Switch>
  );
}
